export class Crt {
    regimenRetencion: string;
    tasaRetencion: string;
    importeTotalRetenido: string;
    monedaImporteTotalRetenido: string;
    importeTotalPagado: string;
    monedaImporteTotalPagado: string;


    constructor(regimenRetencion: string = '01',
                tasaRetencion: string = '3.00',
                importeTotalRetenido: string = '',
                monedaImporteTotalRetenido: string = 'PEN',
                importeTotalPagado: string = '',
                monedaImporteTotalPagado: string = 'PEN') {
        this.regimenRetencion = regimenRetencion;
        this.tasaRetencion = tasaRetencion;
        this.importeTotalRetenido = importeTotalRetenido;
        this.monedaImporteTotalRetenido = monedaImporteTotalRetenido;
        this.importeTotalPagado = importeTotalPagado;
        this.monedaImporteTotalPagado = monedaImporteTotalPagado;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/crt.ts